import {Button, CircularProgress, DialogContent, Grid,} from '@material-ui/core';
import {hideModal} from 'Core/ducks/modal';
import {Empty, isLoaded} from 'Core/models/Async';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Modal from 'Shared/components/Modal';
import {changeInteractiveFormStates} from 'Agent/AgentForms/Interactive/ducks/interactiveFormState';
import {InteractiveFormStateDto} from 'Agent/AgentForms/Interactive/models/Interactive';

type InteractiveFormStatesProps = {
    states: InteractiveFormStateDto;
    hideModal: () => void;
};

const InteractiveFormStatesModel = (props: InteractiveFormStatesProps) => {
    const dispatch = useDispatch();
    const response = useSelector((state: ReducerState) => state.interactiveFormState);
    useEffect(() => {
        return () => {
            dispatch(changeInteractiveFormStates(new Empty()));
        };
    }, [dispatch]);

    return (
        <Modal title="States" open onClose={() => dispatch(hideModal())}>
            <DialogContent className="inter-states-modal__dialogPaper">
                <Grid container direction="column" alignItems="center">
                    {response && isLoaded(response) ? (
                        <div className="inter-states-modal">
                            <div className="inter-states-modal__statesBody" key={`inter-states-modal-states-body`}>
                                <p>
                                    {response.Data.join(', ')}
                                </p>
                            </div>
                            <div className="inter-states-modal__closeButton" key={`inter-states-modal-states-close`}>
                                <Button onClick={props.hideModal} fullWidth variant="contained" color="primary">
                                    Close
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <CircularProgress color="primary"/>
                    )}
                </Grid>
            </DialogContent>
        </Modal>
    );
};

export default InteractiveFormStatesModel;
